<ion-item [lines]="lines" [color]="color" *ngIf="timeEntry">
	<ion-grid>
		<!-- Ticket Code -->
		<ion-row>
			<ion-col size="4" size-sm>
				<ion-label class="ion-text-wrap bold">
					Ticket Code:
				</ion-label>
			</ion-col>
			<ion-col size="8" size-sm>
				<ion-text>
					{{ timeEntry.timeCodeDesc }}
				</ion-text>
			</ion-col>
		</ion-row>
		<!-- Pay Code -->
		<ion-row>
			<ion-col size="4" size-sm>
				<ion-label class="ion-text-wrap bold">
					Pay Code:
				</ion-label>
			</ion-col>
			<ion-col size="8" size-sm>
				<ion-text>
					{{ timeEntry.payCodeDesc }}
				</ion-text>
			</ion-col>
		</ion-row>
		<!-- Service -->
		<ion-row>
			<ion-col size="4" size-sm>
				<ion-label class="ion-text-wrap bold">
					Service:
				</ion-label>
			</ion-col>
			<ion-col size="8" size-sm>
				<ion-text>
					{{ timeEntry.customerServiceDesc }}
				</ion-text>
			</ion-col>
		</ion-row>
		<!-- Duration -->
		<ion-row>
			<ion-col size="4" size-sm>
				<ion-label class="ion-text-wrap bold">
					Duration:
				</ion-label>
			</ion-col>
			<ion-col size="8" size-sm>
				<ion-text>
					{{ getMinutesFormatted(timeEntry.minutes) }}
				</ion-text>
			</ion-col>
		</ion-row>
		<!-- Capital -->
		<ion-row>
			<ion-col size="4" size-sm>
				<ion-label class="ion-text-wrap bold">
					Capital:
				</ion-label>
			</ion-col>
			<ion-col size="8" size-sm>
				<ion-text>
					{{ timeEntry.capital ? "Yes" : "No" }}
				</ion-text>
			</ion-col>
		</ion-row>
		<!-- Note -->
		<ion-row>
			<ion-col size="4" size-sm>
				<ion-label class="ion-text-wrap bold">
					Note:
				</ion-label>
			</ion-col>
			<ion-col size="8" size-sm>
				<app-scrollable-text>
					{{ timeEntry.note || "N/A" }}
				</app-scrollable-text>
			</ion-col>
		</ion-row>
		<ion-row *ngIf="!readonly">
			<ion-col size="6" size-sm>
				<ion-button expand="block" (click)="onClickShowForm()">
					Edit
				</ion-button>
			</ion-col>
			<ion-col size="6" size-sm>
				<ion-button
					*ngIf="canDelete()"
					expand="block"
					(click)="onClickDeleteTimeEntry()"
					color="danger"
				>
					Delete
				</ion-button>
			</ion-col>
		</ion-row>
	</ion-grid>
</ion-item>
